import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'
import { GROUP_ACTIVITY_STATE } from '@/config/constants'

const state = {
  selectGoodsList: [], // 选中的商品信息列表
  selectStoreInfo: {}, // 选中的门店信息
  judgeStatus: 2, // 2不获取，1获取
  groupActivityContent: '', // 活动文本内容
  groupBuyActivity: {}, // 活动内容
  groupBuyActivityStoreInfo: [],
  groupBuyActivityState: GROUP_ACTIVITY_STATE.pending, // 存储活动列表当前选择的活动状态 (默认设置为进行中)
  groupBuyDetailActivityState: GROUP_ACTIVITY_STATE.pending, // 存储活动详情中的活动状态 (默认设置为进行中)
  isBackGeneralCode: false // 订单页是否从扫码点单核销页返回的
}

const mutations = {
  /**
   * @function 添加选中商品
   * @author gxl
   * @param state
   * @param data
   */
  [types.SAVE_SELECT_GOODS] (state, data) {
    console.log(data, 'data-add')
    state.selectGoodsList.push(data)
    console.log(state.selectGoodsList, 'state.selectGoodsList')
  },
  /**
   * @function 取消选中商品
   * @author gxl
   * @param state
   * @param data
   */
  [types.DELETE_SELECT_GOODS] (state, data) {
    console.log(data, 'data-delete')
    state.selectGoodsList.splice(data, 1)
    console.log(state.selectGoodsList, 'state.selectGoodsList')
  },
  /**
   * @function 更新选中商品信息
   * @author gxl
   * @param state
   * @param data
   */
  [types.UPDATE_SELECT_GOODS] (state, data) {
    console.log(data, 'data-update')
    state.selectGoodsList = data
    console.log(state.selectGoodsList, 'state.selectGoodsList')
  },
  /**
   * @function 清空选中的商品
   * @param state
   * @param data
   */
  [types.CLEAR_SELECT_GOODS] (state, data) {
    console.log(data, 'data-clear')
    state.selectGoodsList = []
    console.log(state.selectGoodsList, 'state.selectGoodsList')
  },
  /**
   * @function 保存选中门店信息
   * @param state
   * @param data
   */
  [types.SAVE_SELECT_STORE] (state, data) {
    console.log(data, 'store')
    state.selectStoreInfo = {
      ...data
    }
    console.log(state.selectStoreInfo, 'state.selectStoreInfo')
  },
  /**
   * @function 判断是否可以获取store的商品数据
   * @param state
   * @param data
   */
  [types.JUDGE_GET_GOOD_LIST] (state, data) {
    console.log(data, 'judgeStatus')
    state.judgeStatus = data
    console.log(state.judgeStatus, 'state.judgeStatus')
  },
  /**
   * @function 存储活动文本内容
   * @param state
   * @param data
   */
  [types.SAVE_GROUP_BUY_CONTENT] (state, data) {
    console.log(data, 'groupActivityContent')
    state.groupActivityContent = data
    console.log(state.groupActivityContent, 'state.groupActivityContent')
  },
  /**
   * @function 保存活动内容
   * @param state
   * @param data
   */
  [types.SAVE_GROUP_BUY_ACTIVITY] (state, data) {
    console.log(data, 'groupBuyActivity')
    state.groupBuyActivity = data
    console.log(state.groupBuyActivity, 'state.groupBuyActivity')
  },
  /**
   * @function 保存选择活动门店id
   * @param state
   * @param data
   */
  [types.SAVE_GROUP_BUY_ACTIVITY_STORE_INFO] (state, data) {
    console.log(data, 'groupBuyActivityStoreInfo')
    state.groupBuyActivityStoreInfo = data
    console.log(state.groupBuyActivityStoreInfo, 'state.groupBuyActivityStoreInfo')
  },
  /**
   * @function 发布完活动，清空数据
   * @param state
   * @param data
   */
  [types.CLEAR_GROUP_BUY_ALL_INFO] (state) {
    state.groupBuyActivityStoreInfo = []
    state.selectGoodsList = [] // 选中的商品信息列表
    state.selectStoreInfo = {} // 选中的门店信息
    state.judgeStatus = 2 // 2不获取，1获取
    state.groupActivityContent = '' // 活动文本内容
    state.groupBuyActivity = {} // 活动内容
    state.groupBuyActivityStoreInfo = []
  },
  /**
   * @function 保存活动列表当前选中的tab状态
   * @param state
   * @param data
   */
  [types.SET_GROUPBUY_ACTIVITY_STATE] (state, data) {
    state.groupBuyActivityState = data
  },
  /**
   * @function 保存活动详情状态
   * @param state
   * @param data
   */
  [types.SET_GROUPBUY_DETAIL_ACTIVITY_STATE] (state, data) {
    state.groupBuyDetailActivityState = data
  },
  /**
   * @function 订单页是否从扫码点单核销页返回的
   * @param state
   * @param data
   */
  [types.SET_IS_BACK_GENERAL_CODE] (state, data) {
    state.isBackGeneralCode = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
